var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import CheckIcon from '@mui/icons-material/Check';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// shadcn-style checkbox on `@radix-ui/react-checkbox` (keyboard + a11y for free). Keeps a
// plain boolean API; the MUI Check icon replaces shadcn's default lucide one (repo convention).
export const Checkbox = (_a) => {
    var { checked, onCheckedChange, id, className } = _a, props = __rest(_a, ["checked", "onCheckedChange", "id", "className"]);
    return (<CheckboxPrimitive.Root id={id} checked={checked} onCheckedChange={value => onCheckedChange(value === true)} className={cn('flex h-4 w-4 shrink-0 items-center justify-center rounded border border-solid border-white/20 bg-white/[0.03] text-white transition-colors hover:border-white/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 data-[state=checked]:border-primary data-[state=checked]:bg-primary', className)} {...props}>
		<CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
			<CheckIcon sx={{ fontSize: 12 }}/>
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>);
};
